/* eslint-disable no-mixed-spaces-and-tabs */
import Types from './Types';

const handleLoader = fetchName => {
	return ({
		type: Types.API_HANDLE_MARKETS_OVERVIEW_CHART_LOADER,
		fetchName
	});
};

const receiveMarketsOverviewChart = response => {
	return ({
		type: Types.API_RECEIVE_MARKETS_OVERVIEW_CHART,
		response
	});
};

const requestMarketsOverviewChart = () => {
	// The charts are always coming from the same 4 xids so they're hard coded in
	return {
		type: Types.API_REQUEST_MARKETS_OVERVIEW_CHART,
		endPoint: '/charts-spark/v1/spark',
		ajaxType: 'POST',
		params: {
			instruments: [
			 { venueXid: 593253 }, { venueXid: 599362 }, { venueXid: 579435 }, { venueXid: 593933 }
			],
			data: {
			  days: 1,
			  interval: 5,
			  period: 'minute',
			  realTime: false
			},
			height: 41,
			width: 97,
			imageFormat: 'png',
			returnSprite: false,
			styles: {
			  markers: {
					price: {
						primary: {
							colorIndex: 1,
							width: 1,
							colorIndexNeg: 2,
							colorIndexPos: 3,
							colorMode: 'dual'
						}
					},
					reference: {
						colorIndex: 1,
						width: 2,
						colorMode: 'default',
						dash: [
							1,
							1
				  		]
					}
			  },
			  background: {
					colorIndex: -1
			 },
			 colors: [
				   '#FFFFFF',
				   '#5F6064',
				   '#C0202D',
				   '#1D8343',
				   '#CCE1D8',
				   '#ECD3D5'
				]
			},
			markers: {
				fullInterval: true,
			  reference: {
					basis: 'previousClose'
			  }
			}
		  },

		onSuccess: receiveMarketsOverviewChart,
		loader: handleLoader,
		fetchName: 'fetchingMarketsOverviewChart'
	};
};

export {
	requestMarketsOverviewChart,
	receiveMarketsOverviewChart
};
